import { v4 as uuid } from "uuid"
import { omit } from "radash"

import type { CustomFieldInput } from "~components/forms/custom-field-form-input-helpers"

const TEMP_ID_PREFIX = "temp-"

export function getTempId() {
    return `${TEMP_ID_PREFIX}${uuid()}`
}

export function removeTempIds(inputs: CustomFieldInput[]) {
    return inputs.map((input) => {
        if (!input.id.startsWith(TEMP_ID_PREFIX)) return input

        return omit(input, ["id"])
    })
}
